import React from "react";
import { Link } from "react-router-dom";
import BGImage from "../assets/img/Designer.webp";
import { motion } from "framer-motion";

const NotFound: React.FC = () => {
  return (
    <main
      className="relative flex flex-col items-center justify-center min-h-screen py-16 px-6 bg-cover bg-center"
      style={{
        backgroundImage: `url(${BGImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Semi‐transparent overlay to ensure readability */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        style={{
          backgroundImage: `url(${BGImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="relative z-10 text-center px-8 py-20 max-w-3xl w-full"
      >
        <motion.p
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="text-[142px] md:text-[160px] font-extrabold text-secondary-light mb-6"
        >
          Page Not Found
        </motion.p>

        <motion.div
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          <Link
            to="/"
            className="inline-block bg-primary text-white px-8 py-3 text-lg font-bold hover:bg-primary-dark transition"
          >
            Back to homepage
          </Link>
        </motion.div>
      </motion.div>
    </main>
  );
};

export default NotFound;
